export default {
	custom : {
		email : {
			required : 'El campo email es obligatorio',
			email : 'Debes indicar una dirección de correo electrónico válida'
		},
		telefono : {
			required : 'El campo teléfono es obligatorio',
			length : 'El campo teléfono está mal formado'
		},
		phone : {
			required : 'El campo teléfono es obligatorio',
			length : 'El campo teléfono está mal formado'
		},
		telefonollamamos : {
			required : 'El campo teléfono es obligatorio',
			length : 'El campo teléfono está mal formado'
		},
		nombre : {
			required : 'El campo nombre es obligatorio'
		},
		name : {
			required : 'El campo nombre es obligatorio'
		},
		mensaje : {
			required : 'El campo mensaje es obligatorio'
		},
		apellidos : {
			required : 'El campo apellidos es obligatorio'
		},
		apellido : {
			required : 'El campo apellido es obligatorio'
		},
		apellido_2 : {
			required : 'El campo apellido es obligatorio'
		},
		politica : {
			required : 'Debes aceptar la política de privacidad'
		},
		politica_telefono : {
			required : 'Debes aceptar la política de privacidad'
		},
		direccion : {
			required : 'El campo direccion es obligatorio'
		},
		pais : {
			required : 'El campo pais es obligatorio'
		},
		carta_presentacion : {
			required : 'El campo carta de presentación es obligatorio'
		},
		doc_adjunto : {
			size : 'El tamaño maximo son 2MB',
			mimes : 'El formato debe ser PDF'
		},
		dni :{
			required : "El campo DNI/CIF es obligatorio",
			length : "El documento de identidad no es válido. Escribe tu número completo y letra."
		},
		provincia :{
			required : "El campo provincia es obligatorio"
		},
		localidad :{
			required : "El campo localidad es obligatorio"
		},
		codigopostal :{
			required : "El campo código postal es obligatorio"
		},
		direccion_calle :{
			required : "El campo calle es obligatorio"
		},
		cuentabancaria : {
			required : "El campo cuenta bancaria es obligatorio",
			length: "Error. Revisa que estén correctos todos los números de tu cuenta.",
			checkiban : "El IBAN está mal formado"
		},
		banco_dni : {
			required : "El campo DNI/CIF es obligatorio"
		},
		banco_nombre : {
			required : "El campo nombre es obligatorio"
		},
		banco_apellidos : {
			required : "El campo apellidos es obligatorio"
		},
		facturacion_dni : {
			required : "El campo DNI/CIF es obligatorio"
		},
		facturacion_nombre : {
			required : "El campo nombre es obligatorio"
		},
		facturacion_apellidos : {
			required : "El campo apellidos es obligatorio"
		},
		facturacion_email : {
			required : "El campo email es obligatorio"
		},
		facturacion_telefono : {
			required : "El campo teléfono es obligatorio",
			length : "El campo teléfono esta mal formado"
		},
		facturacion_direccion_cp : {
			required : "El campo código postal es obligatorio",
			length : "El campo código postal está mal formado"
		},
		facturacion_direccion_provincia : {
			required : "El campo provincia es obligatorio"
		},
		facturacion_direccion_localidad : {
			required : "El campo localidad es obligatorio"
		},
		facturacion_direccion_calle : {
			required : "El campo dirección completa es obligatorio"
		},
		facturacion_dni : {
			required : "El campo DNI/CIF es obligatorio"
		},
		legales : {
			required : "La aceptación de los terminos legales es obligatorio"
		},
		file : {
			image : "El formato de la firma adjunta no es valido",
			size : "El tamaño de la firma adjunta es superior al permitido"
		},
		preciotarifa : {
			required : "Debes elegir el tipo de precio de tu tarifa"
		},
		cups : {
			required : 'El campo CUPS es obligatorio',
			min : 'EL CUPS está mal formado',
			max : 'EL CUPS está mal formado'
		},
		telefonollamanos : {
			required : 'El teléfono es obligatorio',
			length : 'El teléfono está mal formado',
		},
		comercializadora : {
			required : "Debes elegir la comercializadora con la que estás actualmente"
		},
		tipovivienda : {
			required : "Dinos cual es tu tipo de vivienda"
		},
		calculoexacto : {
			required : 'Necesitamos saber este dato para hacer la simulación'
		},
		pago : {
			required : 'Necesitamos saber cuánto pagas para poder calcular tu ahorro',
			ownnumeric : 'El valor tiene que ser numerico'
		},
		preciopotencia : {
			required : 'Este campo es obligatorio',
			ownnumeric : 'El valor tiene que ser numerico'
		},
		preciovalle : {
			required : 'Este campo es obligatorio',
			ownnumeric : 'El valor tiene que ser numerico'
		},
		preciopunta : {
			required : 'Este campo es obligatorio',
			ownnumeric : 'El valor tiene que ser numerico'
		},
		preciocuotafija : {
			required : 'Este campo es obligatorio',
			ownnumeric : 'El valor tiene que ser numerico'
		},
		primeravivienda : {
			required : 'Este campo es obligatorio'
		},
		aireacondicionado : {
			required : 'Este campo es obligatorio'
		},
		calefaccioncentral : {
			required : 'Este campo es obligatorio'
		},
		precioenergia : {
			required : 'Este campo es obligatorio'
		},
		mantenimiento : {
			required : 'Necesitamos saber el tipo de mantenimiento de tu caldera que quieres'
		},
		company_name : {
			required : 'El campo nombre de la empresa es obligatorio'
		},
		cif : {
			required : 'El campo CIF de la empresa es obligatorio',
			length : "El campo CIF de la empresa no es válido. Escribe el número completo y letra."
		},
		cname : {
			required : 'El campo actividad es obligatorio'
		},
		'horas-semana' : {
			required : 'Debes seleccionar las horas'
		},
		'horas-findesemana' : {
			required : 'Debes seleccionar las horas'
		},
		first_house : {
			required : 'Este campo es obligatorio'
		},
		ac : {
			required : 'Este campo es obligatorio'
		},
		central_heat : {
			required : 'Este campo es obligatorio'
		},
		aerotermina : {
			required : 'Este campo es obligatorio'
		},
		rent_house : {
			required : 'Este campo es obligatorio'
		},
	}
}


// WEBPACK FOOTER //
// ./src/validator/es.js